export default __webpack_public_path__ + "static/media/WEBINAR_liderazgo_scania-REGISTRO.76c47491.jpg";